module.exports = __webpack_public_path__ + "img/GALLERY-VITARA-2.6828d4ea.jpg";